import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';

import { weekDays } from './constants';
import { ScheduleWeek } from './types';
import { checkIfDayHasConflicts, convertMinutesToTimeString } from './utils';

const SchedulePreviewDayRow: React.FC<{ title: string }> = ({ title, children }) => {
  return (
    <Box display="flex" mb={2}>
      <Box sx={{ width: '120px' }}>{title}</Box>
      <Typography>{children}</Typography>
    </Box>
  );
};

export interface SchedulePreviewProps {
  schedule: ScheduleWeek;
  // each position in this array represents a day in the week: [0] - Monday, [6] - Sunday
  weekDayStrings: string[];
  strings: Record<'closed', string>;
}

export const SchedulePreview: React.FC<SchedulePreviewProps> = memo(
  ({ schedule, weekDayStrings, strings }) => {
    return (
      <Box>
        {schedule &&
          weekDays.map((index) => {
            const intervals = schedule[index] || [];
            const title = weekDayStrings[index];
            const hasConflicts = checkIfDayHasConflicts(intervals);

            return (
              <Box
                key={index}
                pt={2}
                sx={{
                  ...(hasConflicts && {
                    color: 'colors.red500',
                  }),
                }}
              >
                {intervals.length ? (
                  intervals.map(([start, stop], intervalIndex) => {
                    const key = `${start}-${stop}-${intervalIndex}`;
                    const isFirst = intervalIndex === 0;

                    return (
                      <SchedulePreviewDayRow key={key} title={isFirst ? title : ''}>
                        {[start, stop].map(convertMinutesToTimeString).join(` - `)}
                      </SchedulePreviewDayRow>
                    );
                  })
                ) : (
                  <SchedulePreviewDayRow title={title}>{strings.closed}</SchedulePreviewDayRow>
                )}
              </Box>
            );
          })}
      </Box>
    );
  },
);
